/*
 * File: ZoomColumnGrid.tsx
 * Project: a-a
 * File Created: Friday, 24th October 2025 9:29:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 17th November 2025 11:23:49 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Zoom } from '@mui/material';
import React from 'react';
import ZoomInfoCard from '../ZoomInfoCard/ZoomInfoCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';

const ZoomColumnGrid = ({
  data,
  getData,
  loading,
  getUpdates,
  category,
}: {
  data: any;
  getData: () => Promise<void>;
  loading: boolean;
  getUpdates: any;
  category: string;
}) => {
  console.log('total', data?.items?.length || 0, data?.total);
  return (
    <InfiniteScroll
      dataLength={Math.floor(data?.items?.length) || 0}
      loader={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // visibility: 'hidden',
          }}
        >
          <h4></h4>
        </Box>
      }
      next={() => {
        console.log('next');
        getData();
        // next(true);
      }}
      hasMore={data?.items?.length < data?.total}
      height={'calc(100vh - 280px)'}
      // height={'100vh'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        // paddingBottom: '1rem',
        // overflowY: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          //   gridTemplateColumns: {
          //     xs: 'repeat(auto-fill, minmax(400px, 1fr))', // Responsive columns
          //     xl: 'repeat(auto-fill, minmax(580px, 1fr))',
          //   },
          gap: '24px',
          // overflowY: 'auto',
          // gridAutoRows: 'min-content', // Make rows only as tall as content
          // gridAutoFlow: 'row',
          // // height: '65vh',
          // // height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
          // alignItems: 'start',
          // '& > a': {
          //   // Target all Link elements directly inside the grid
          //   height: 'auto',
          //   display: 'block',
          // },
        }}
      >
        {' '}
        {loading &&
          [1, 2, 3, 4, 5, 6].map((item) => (
            <ZoomInfoCard
              key={item}
              loading={loading}
              getUpdates={getUpdates}
              category={category}
            />
          ))}
        {data?.items?.map((item: any) => (
          <ZoomInfoCard
            key={item.id}
            data={item}
            loading={loading}
            getUpdates={getUpdates}
            category={category}
          />
        ))}
      </Box>
    </InfiniteScroll>
  );
};

export default ZoomColumnGrid;
